import { AppFlexBody } from "./App.styles";
import ImageUpload from "./components/ImageUpload/ImageUpload";

function App() {
  return (
    <AppFlexBody>
      <ImageUpload />
    </AppFlexBody>
  );
}

export default App;
